import { InfoWindowF, MarkerF } from '@react-google-maps/api';
import * as React from 'react';
import { markerStatusMap } from './status-marker-map';

const Markers = ({marker, ids, index, focusedIndex, handleClick}) => {
	const [selectedMarker, setSelectedMarker] = React.useState(false);	
	const handleMouseOver = React.useCallback(() => {
    setSelectedMarker(true);
  }, []);

  const handleMouseOut = React.useCallback(() => {
    setSelectedMarker(false);
  }, []);

	return(
		marker.wanAvailabilityStatus && marker.location && marker.fullAddress &&
		<MarkerF
      key={ids}
      icon={
				markerStatusMap(marker.wanAvailabilityStatus)
      }
      position={{
				lat: +marker.location.lat,
				lng: +marker.location.lon
			}}
      onMouseOver={() => handleMouseOver()}
      onMouseOut={handleMouseOut}
      onClick={() => handleClick(marker?.id)}
    >
      {(selectedMarker || (focusedIndex === index)) ? (
        <InfoWindowF
					position={{
						lat: +marker.location.lat,
						lng: +marker.location.lon
					}}
          onCloseClick={() => setSelectedMarker(false)}
        >
          <>
          <div>{marker.fullAddress}</div>
          <br/>
          <br/>
          <p><b>Status: </b>{marker.wanAvailabilityStatus}</p>
          </>
        </InfoWindowF>
      ) : null}
    </MarkerF>
	)
}

export default Markers;